import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { get } from 'lodash';
import { BuyErrors, BuyerOfferActionDto, Offer, PurchaseActionService } from 'remarketing-angular-library';
import { Observable, of } from 'rxjs';
import { OfferModalItem } from '../../../../shared/models/offer-modal-item.model';
import { OfferModalEvent } from 'smartauction-frontend-micro-library';

@Injectable({
  providedIn: 'root'
})
export class OfferModalsService {
  constructor(readonly purchaseActionService: PurchaseActionService) {}

  /** isSpareKeyIncludedInPurchase is only sent on accept, and only when the caller passes it. */
  handleOfferEvent(event: OfferModalEvent, item: OfferModalItem, isSpareKeyIncludedInPurchase?: boolean): Observable<Offer> {
    if (event.type === 'MakeOffer') {
      const payload = {
        amount: event.offerAmount,
        auctionItemUuid: item.auctionItemUuid,
        buyerOeUuid: item.buyerOeUuid,
        comment: event.comments,
        financeSourceUuid: item.financeSourceUuid,
        financeSourceAch: item.financeSourceAch,
        localDelivery: item.localDelivery
      };
      return this.purchaseActionService.newOffer(payload);
    } else if (event.type === 'WithdrawOffer' || event.type === 'DeclineOffer' || event.type === 'AcceptOffer') {
      const payload: BuyerOfferActionDto = {
        offerUuid: event.offerUuid,
        requestedAction: event.requestedAction,
        comment: event.comments
      };
      if (event.type === 'AcceptOffer' && isSpareKeyIncludedInPurchase !== undefined) {
        payload.isSpareKeyIncludedInPurchase = isSpareKeyIncludedInPurchase;
      }
      return this.purchaseActionService.offerAction(payload);
    } else if (event.type === 'CounterOffer') {
      const payload = {
        amount: event.counterOfferAmount,
        auctionItemUuid: item.auctionItemUuid,
        buyerOeUuid: item.buyerOeUuid,
        comment: event.comments,
        financeSourceUuid: item.financeSourceUuid,
        financeSourceAch: item.financeSourceAch,
        localDelivery: item.localDelivery
      };

      return this.purchaseActionService.counterOffer(event.offerUuid, payload);
    }
    // Implicitly handle the Cancel event
    return of({} as Offer);
  }

  /**
   * Basic handling of mapping error messages to text errors. It may need modification in the future
   * but we can test all available errors to make sure.
   */

  handleOfferError(errorResponse: HttpErrorResponse): Observable<string> {
    if (errorResponse.error instanceof ErrorEvent) {
      return of(BuyErrors.MSG_BUY_002);
    }
    if (errorResponse.status === 404) {
      return of(BuyErrors.MSG_BUY_013);
    }
    try {
      const error = get(errorResponse, 'error.errors[0]');
      return of(BuyErrors.fromBuyErrors(error.code));
    } catch (e) {
      return of(BuyErrors.MSG_BUY_002);
    }
  }
}
